// extracted by mini-css-extract-plugin
export default {"route-button":"MainPage_route-button__74k6p","rb-disabled":"MainPage_rb-disabled__WjrxE"};